import { motion } from "framer-motion";
import { cn } from "@/lib/cn";

const SPRING = { type: "spring" as const, stiffness: 300, damping: 30 };

const SECTION_VARIANTS = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: SPRING },
};

interface TemplateCard {
  emoji: string;
  name: string;
  description: string;
}

const CONTENT_TEMPLATES: TemplateCard[] = [
  { emoji: "\u{1F4E6}", name: "Product", description: "Showcase a product with details" },
  { emoji: "\u{1F389}", name: "Promotion", description: "Announce a sale or discount" },
  { emoji: "\u{1F525}", name: "Daily Deal", description: "Highlight today's best offer" },
  { emoji: "⭐", name: "Testimonial", description: "Share customer feedback" },
  { emoji: "\u{1F4CB}", name: "Price List", description: "Display current pricing" },
  { emoji: "\u{1F550}", name: "Business Hours", description: "Share operating schedule" },
];

export function ContentTemplatesSection() {
  return (
    <motion.section variants={SECTION_VARIANTS} className="mb-5">
      <h2 className="mb-2 text-xs font-semibold uppercase tracking-wider text-[var(--color-text-muted)]">
        Content Templates
      </h2>
      <div className="grid grid-cols-2 gap-3">
        {CONTENT_TEMPLATES.map((template) => (
          <button
            key={template.name}
            type="button"
            className={cn(
              "flex flex-col items-start gap-2 rounded-[var(--radius-lg)] p-3.5",
              "bg-[var(--color-surface)] shadow-sm text-left transition-colors",
              "active:bg-[var(--color-border-subtle)]",
            )}
            aria-label={`Use ${template.name} template`}
          >
            <span className="text-xl">{template.emoji}</span>
            <div>
              <p className="text-sm font-medium text-[var(--color-text)]">
                {template.name}
              </p>
              <p className="mt-0.5 text-[11px] leading-snug text-[var(--color-text-muted)]">
                {template.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </motion.section>
  );
}
